export interface ContextualElementSettings {
  textScale: number
  textColor: string | null
  backgroundColor: string | null
  visible: boolean
}

export type ContextualSettingsMap =
  Record<string, ContextualElementSettings>

export const DEFAULT_CONTEXTUAL_ELEMENT:
ContextualElementSettings = {
  textScale: 1,
  textColor: null,
  backgroundColor: null,
  visible: true,
}

const STORAGE_KEY =
  'sei-genesis-contextual-r7'

export function loadContextualSettings():
ContextualSettingsMap {
  try {
    const raw =
      localStorage.getItem(
        STORAGE_KEY,
      )

    if (!raw) {
      return {}
    }

    return JSON.parse(
      raw,
    ) as ContextualSettingsMap
  } catch {
    return {}
  }
}

export function saveContextualSettings(
  value: ContextualSettingsMap,
): void {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify(value),
  )
}

export function clearContextualSettings():
void {
  localStorage.removeItem(
    STORAGE_KEY,
  )
}
